import React, { useState } from "react";
import Button from "@mui/material/Button";
import ImportExport from "@mui/icons-material/ImportExport";
import { Plus } from "react-feather";
import { FileCopy, Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { DeleteConfirmModal } from "../../Modals/ConfirmModal/ConfirmModal";

export const ButtonImport = (props) => {
  return (
    <Button
      id={props.id}
      variant="contained"
      color="primary"
      onClick={props.onClick}
      style={{
        marginBottom: "1rem",
      }}
    >
      <ImportExport /> &nbsp;{props.title}
    </Button>
  );
};

export const ButtonClose = (props) => {
  const { t } = useTranslation();

  return (
    <Button
      id={props.id}
      variant="contained"
      color="secondary"
      onClick={props.onClick}
    >
      {t("Global.close")}
    </Button>
  );
};

export const ButtonDelete = (props) => {
  const { t } = useTranslation();

  const [state, setState] = useState({
    showDeleteConfirmationModal: false,
  });

  const deleteItem = (e) => {
    if (props.title == null) {
      props.onClick(e);
    } else {
      setState({
        showDeleteConfirmationModal: true,
      });
    }
  };

  const confirmationModal = state.showDeleteConfirmationModal ? (
    <DeleteConfirmModal
      actionOk={() => {
        setState({
          showDeleteConfirmationModal: false,
        });
        props.onClick();
      }}
      actionCancel={() => {
        setState({
          showDeleteConfirmationModal: false,
        });
      }}
    >
      <span>
        {t("Global.delete_confirm")}{" "}
        <span style={{ color: "red", fontWeight: "bold" }}>{props.title}</span>?
      </span>
    </DeleteConfirmModal>
  ) : null;

  const style = props.style ? props.style : { marginLeft: "0px" };
  const className = props.className ? props.className : "";
  const disableDelete = props.disableDelete ? props.disableDelete : false;

  return (
    <React.Fragment>
      <Button
        id={props.id}
        onClick={(e) => deleteItem(e)}
        style={style}
        disabled={disableDelete}
        className={"button-delete button-square " + className}
      >
        DELETE
      </Button>
      {confirmationModal}
    </React.Fragment>
  );
};

export const ButtonEdit = (props) => {
  return (
    <Button
      id={props.id}
      onClick={props.onClick}
      style={props.style}
      className={"button-edit button-square"}
    >
      EDIT
    </Button>
  );
};

export const ButtonSave = (props) => {
  const { t } = useTranslation();

  let buttonStyle = { marginRight: "0.25rem" };

  if (props.style) {
    buttonStyle = props.style;
  }

  return (
    <Button
      id={props.id}
      color="primary"
      variant={"contained"}
      className={"button-save"}
      onClick={props.onClick}
      style={buttonStyle}
      disabled={props.disabled}
    >
      SAVE
    </Button>
  );
};

export const ButtonCancel = (props) => {
  const { t } = useTranslation();

  let buttonStyle = { marginRight: "10px", color: "#333" };

  if (props.style) {
    buttonStyle = props.style;
  }

  return (
    <Button
      id={props.id}
      className={"button-cancel"}
      color="secondary"
      variant={"contained"}
      onClick={props.onClick}
      style={buttonStyle}
      disabled={props.disabled}
    >
      CANCEL
    </Button>
  );
};

export const ButtonOK = (props) => {
  const { t } = useTranslation();

  const label = props.label ? props.label : t("Global.ok");

  return (
    <Button
      id={props.id}
      variant="contained"
      color="primary"
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {label}
    </Button>
  );
};

export const ButtonAdd = (props) => {
  let buttonStyle = {
    marginBottom: "1rem",
  };

  if (props.style) {
    buttonStyle = props.style;
  }

  let buttonClassName = "";
  if (props.className) {
    buttonClassName = props.className;
  }

  return (
    <Button
      id={props.id}
      variant="contained"
      color="primary"
      onClick={props.onClick}
      className={buttonClassName}
      style={buttonStyle}
    >
      <Plus />
      &nbsp;{props.title}
    </Button>
  );
};

export const ButtonCopy = (props) => {
  return (
    <Button
      id={props.id}
      variant="contained"
      color="primary"
      onClick={props.onClick}
    >
      <FileCopy />
    </Button>
  );
};

export const ButtonSearch = (props) => {
  const { t } = useTranslation();

  return (
    <Button
      id={props.id}
      variant="contained"
      color="primary"
      onClick={props.onClick}
    >
      <Search />
    </Button>
  );
};

const ButtonGroup = (props) => {
  const { t } = useTranslation();

  const clickDelete = (e) => {
    e.stopPropagation();
    props.delete();
  };

  const clickEdit = (e) => {
    e.stopPropagation();
    props.edit();
  };

  const clickSave = (e) => {
    e.stopPropagation();
    props.save();
  };

  const clickCancel = (e) => {
    e.stopPropagation();
    props.cancel();
  };

  const clickCopy = (e) => {
    e.stopPropagation();
    props.copy();
  };

  let deleteButton;
  if (props.delete != null) {
    deleteButton = (
      <ButtonDelete
        id={"delete-btn-" + props.id}
        onClick={clickDelete}
        variant={props.variant}
        disableDelete={props.disableDelete}
      />
    );
  }

  let copyButton = null;
  if (props.copy) {
    copyButton = (
      <ButtonCopy
        id={"copy-btn-" + props.id}
        onClick={clickCopy}
        variant={props.variant}
      />
    );
  }

  let editButton = null;
  if (!props.hideExpand) {
    editButton = (
      <ButtonEdit
        id={"edit-btn-" + props.id}
        onClick={clickEdit}
        variant={props.variant}
      />
    );
  }

  let actionButton;
  if (props.showBtn) {
    if (props.readonly && !props.deleteOnly) {
      actionButton = (
        <div>
          {props.edit !== null && editButton}
          {deleteButton}
        </div>
      );
    } else if (!props.deleteOnly) {
      actionButton = (
        <div>
          {copyButton}
          <ButtonCancel
            id={"cancel-btn-" + props.id}
            onClick={clickCancel}
            variant={props.variant}
          />
          <ButtonSave
            id={"save-btn-" + props.id}
            onClick={clickSave}
            variant={props.variant}
          />
        </div>
      );
    } else {
      actionButton = <div>{deleteButton}</div>;
    }
  }

  return <div className="button-group-div">{actionButton}</div>;
};

export default ButtonGroup;
